import React, { useEffect, useState } from 'react';
import CardContainer from 'src/components/common/CardContainer.redesign';
import _ from 'lodash';
import AgreementCard from './AgreementCard';
import Card from 'src/components/common/Card.redesign';
import ContractGenerationListDto from 'src/models/leasing/ContractGenerationListDto';
import PagedResultSet from 'src/models/common/PagedResultSet';
import ContractProcessingCard from '../TractComponents/ProcessingAndMaintenance/ContractProcessingCard';

interface IAgreementListProps {
    projectNumber: number;
    clientNumber: number;
    generatedAgreements?: PagedResultSet<ContractGenerationListDto>;
    pageType?: 'ContractGeneration' | 'Processing&Maintenance';
    selectedContracts?: Array<number>;

    navigate?: (path: string) => void;
    incrementPage?: () => void;
    showVoidAgreement?: (agreement: ContractGenerationListDto) => void;
    setSelectedContracts?: (contractIds: Array<number>) => void;
    onUpdateLeaseRecording?: (leaseNumber: number) => void;
}

function AgreementsList(props: IAgreementListProps) {
    const [showNextPage, setShowNextPage] = useState<boolean>(false);

    useEffect(() => {
        if (!!props.generatedAgreements) {
            setShowNextPage(props.generatedAgreements.pageNumber * props.generatedAgreements.pageSize < props.generatedAgreements.totalRecords);
        }
    }, [props.generatedAgreements]);

    const agreementCards = (obj: ContractGenerationListDto) => {
        return (
            <div key={obj.leaseNumber}>
                <AgreementCard
                    projectNumber={props.projectNumber}
                    clientNumber={props.clientNumber}
                    agreement={obj}
                    navigate={props.navigate}
                    showVoidDialog={props.showVoidAgreement}
                />
            </div>
        );
    };

    const processingCards = (obj: ContractGenerationListDto) => {
        return (
            <div key={obj.leaseNumber}>
                <ContractProcessingCard
                    agreement={obj}
                    selectedContracts={props.selectedContracts}
                    readonly={true}
                    setSelectedContracts={props.setSelectedContracts}
                    onUpdateLeaseRecording={props.onUpdateLeaseRecording}
                />
            </div>
        );
    };

    const newCard = () => {
        return (
            <CardContainer nextPageAction={props.incrementPage} showNextPagePanel={showNextPage} buttonPaging={true}>
                {(props.pageType === 'ContractGeneration' && props.generatedAgreements?.items?.length > 0) && props.generatedAgreements.items.map(agreementCards)}
                {(props.pageType === 'Processing&Maintenance' && props.generatedAgreements?.items?.length > 0) && props.generatedAgreements.items.map(processingCards)}
                {props.generatedAgreements?.items?.length === 0 && (
                    <Card>
                        <div className="agreements-card">
                            <div style={{ textAlign: 'center' }}>
                                <p>No Contracts Available!!</p>
                            </div>
                        </div>
                    </Card>
                )}
            </CardContainer>
        );
    };

    return <>{newCard()}</>;
}

export default AgreementsList;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/AgreementsList.tsx